var homeDefaultsRoutes = require("../lib/platform.home.defaults.routes.js");

module.exports = async function(context) {
  var root = document.getElementById("dashboard-role-home-defaults-root");
  if (!root) return;

  var role = (root.getAttribute("data-role-defaults-role") || "").toString().trim();
  if (!role) return;

  var previewRoot = root.querySelector("[data-collection-name='platformRoleDefaultsPreview']");
  if (!previewRoot) return;

  var dashboardApi = (context || {}).dashboardApi || window.DashboardAPI || ((((window.UATools || {}).dashboard || {}).api) || null);
  var collectionRoutes = homeDefaultsRoutes.getCollectionRoutes(context);
  var pageNamespace = collectionRoutes.namespace;
  var apiUrl = collectionRoutes.detail.preview.api;

  if (!(dashboardApi)) return;

  async function refreshPreview() {
    try {
      var response = apiUrl
        ? await dashboardApi.get(pageNamespace, role, apiUrl)
        : await dashboardApi.get(pageNamespace, role);
      if (!(response && response.success && response.data)) return;

      previewRoot.dispatchEvent(new CustomEvent("ua:collection:load", {
        bubbles: true,
        detail: {
          items: response.data.items || []
        }
      }));

      updateBadge("total", response.data.total, "total");
      updateBadge("widgets", response.data.widgets, "widgets");
      updateBadge("shortcuts", response.data.shortcuts, "shortcuts");
    } catch (error) {
      console.error("Unable to refresh role default preview.", error);
    }
  }

  function updateBadge(name, count, suffix) {
    var badge = root.querySelector("[data-role-defaults-badge='" + name + "']");
    if (!badge) return;
    badge.textContent = (Number(count) || 0).toString() + " " + suffix;
  }

  root.addEventListener("ua:collection:action-success", async function(event) {
    var detail = (event && event.detail) || {};
    if ((detail.collectionName || "") !== "platformRoleDefaultsCatalog") return;
    await refreshPreview();
  });
};
